<template>
  <div
    v-if="isDevelopment"
    class="development-banner"
    role="status"
  >
    <strong>DEVELOPMENT SITE</strong>
    <span>Changes here do not affect the live website.</span>
  </div>
</template>

<script>
export default {
  name: 'DevelopmentBanner',
  computed: {
    isDevelopment() {
      return process.env.VUE_APP_ENVIRONMENT === 'development';
    },
  },
};
</script>

<style lang="scss" scoped>
.development-banner {
  align-items: center;
  background: #fff3cd;
  border-bottom: 1px solid #e0ad22;
  color: #5f4700;
  display: flex;
  font-size: 12px;
  gap: 8px;
  justify-content: center;
  padding: 6px 12px;
  position: sticky;
  top: 0;
  z-index: 20;
}
</style>
